if (!customElements.get("lsg-collection-switcher")) customElements.define("lsg-collection-switcher", class LSGCollectionSwitcher extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            buyboxEl: ".lsg-buybox-rebuild",
            button: "button",
            customPrice: ".js-lsg-buybox-rebuild-custom-price-wrap"
        }
        this.buyboxEl = this.closest(this.selectors.buyboxEl);
        this.switcherBtnEls = this.querySelectorAll(this.selectors.button);
        this.headingGroupEl = this.buyboxEl?.querySelector(`.lsg-heading-group`);
        this.overrideATC = this.closest('.lsg-buybox-rebuild__parent-holder')?.getAttribute('data-override-ATC');
        this.switcherBuyBoxName = this.closest('.lsg-buybox-rebuild__parent-holder')?.getAttribute('data-switcher-buy-box-name');
        this.switcherSections = this.closest('.lsg-buybox-rebuild__parent-holder')?.getAttribute('data-switcher-sections');
        this.switcherATC = this.closest('.lsg-buybox-rebuild__parent-holder')?.getAttribute('data-switcher-atc');
        if (this.switcherATC != null) {
            this.switcherATC = JSON.parse(this.switcherATC);
        }
        this.customPriceWrap = this.closest('.lsg-buybox-rebuild__parent-holder')?.querySelector(this.selectors.customPrice);
        this.customPriceData = this.closest('.lsg-buybox-rebuild__parent-holder')?.getAttribute('data-custom-price');
        if (this.customPriceData != null) {
            this.customPriceData = JSON.parse(this.customPriceData);
        }
        this.init();
    }

    customPrice(productId) {
        if (this.customPriceWrap != null && this.customPriceData != null) {
            let priceData = undefined;
            priceData = this.customPriceData.blocks.find((element) => element.id == productId);

            if (priceData == undefined) {
                this.customPriceWrap.style.display = "none";
            } else {
                this.customPriceWrap.innerHTML = `${priceData.compare_at_price != "" ? '<div class="lsg-buybox-rebuild__custom-compare-at-price lsg-body-small"><s>' + priceData.compare_at_price + '</s></div>' : ""}
                    ${priceData.price != "" ? '<div class="lsg-buybox-rebuild__custom-price"><strong>' + priceData.price + '</strong></div>' : ""}
                    ${priceData.discount != "" ? '<div class="lsg-buybox-rebuild__custom-discount lsg-body-small">' + priceData.discount + '</div>' : ""}`
                this.customPriceWrap.style.display = "";
            }
        }

    }

    init() {
        this.switcherBtnEls.forEach((switcherBtnEl) => {
            const productURL = switcherBtnEl.getAttribute(`lsg-product-url`);
            const newProductHandle = switcherBtnEl.getAttribute(`lsg-switcher-handle`);
            let atcOverrideURL = switcherBtnEl.getAttribute(`lsg-switcher-atc-override`);
            const loadingEl = switcherBtnEl.querySelector(`.lds-ring`);
            switcherBtnEl.addEventListener(`click`, () => {
                loadingEl.style.display = `block`;

                fetch(`${productURL}/?sections=${this.switcherSections}`)
                    .then(response => response.json())
                    .then(data => {
                        const parser = new DOMParser();

                        // BUYBOX
                        const htmlBuybox = parser.parseFromString(data[this.switcherBuyBoxName], 'text/html');
                        if (this.switcherBuyBoxName == "lsg-buybox-rebuild-v2") {
                            const newSectionBuybox = htmlBuybox.querySelector(`lsg-buybox-rebuild`);
                            const oldSectionBuybox = this.buyboxEl;
                            if (this.headingGroupEl) {
                                newSectionBuybox.querySelector(`.lsg-page-width`).appendChild(this.headingGroupEl);
                            }
                            oldSectionBuybox.closest(".lsg-buybox-rebuild__parent-holder").append(newSectionBuybox);
                            const windowScrollY = window.scrollY;
                            const productId = htmlBuybox.querySelector(`.lsg-buybox-rebuild__parent-holder`)?.getAttribute('data-switcher-product-id');

                            if (this.overrideATC == "true" && atcOverrideURL !== '') {
                                let atcData = undefined
                                if (this.switcherATC != null) {
                                    atcData = this.switcherATC.blocks.find((element) => element.id == productId);
                                }

                                const atcGroupEl = newSectionBuybox.querySelector(`[lsg-atc-controls]`);
                                const atcBtnEl = newSectionBuybox.querySelector(`[lsg-atc-btn]`);
                                let atcBtnText = atcBtnEl.querySelector(`span`).innerText;

                                if (atcData != undefined) {
                                    atcOverrideURL = atcData.atc_url;
                                    atcBtnText = atcData.atc_text;
                                }

                                const newBtn = document.createElement(`a`);
                                newBtn.classList.add(`lsg-cta`, `lsg-button`, `lsg-button__style-1`);
                                newBtn.setAttribute(`href`, atcOverrideURL);

                                const newSpan = document.createElement(`span`);
                                newSpan.innerText = atcBtnText;
                                newBtn.append(newSpan);

                                const newDiv = document.createElement(`div`);
                                newDiv.classList.add('lsg-buybox-rebuild__btn-custom')
                                newDiv.append(newBtn);
                                atcGroupEl.replaceWith(newDiv);
                            }

                            oldSectionBuybox.remove();

                            this.customPriceWrap = newSectionBuybox?.querySelector(this.selectors.customPrice);
                            this.customPrice(productId);
                            window.scrollTo({top: windowScrollY, left: 0, behavior: "instant"});

                        }
                    });
            });
        });

    }
})
